import { dropHelpers } from '@/_helpers'

const EDGE_RESERVE = 5 // CM
// const POSIBLE_PALLET_WIDTH = [80, 90, 100, 110, 120] // CM
const HEIGHT_TO_WIDTH_RATIO = 1.1 // height = 1.1 * width
const PALLET_WIDTH_MIN = 30 // CM
const PALLET_WIDTH_MAX = 120 // CM
const PALLET_LENGTH_MIN = 120 // CM
const PALLET_LENGTH_MAX = 650 // CM
const PALLET_WEIGHT_MAX = 1500000 // G
const HEIGHT_OF_PALLET = 15 // CM

// const EUR_PALLET_WIDTH_MIN = 80 // CM
const EUR_PALLET_WIDTH_MAX = 80 // CM
// const EUR_PALLET_LENGTH_MIN = 120 // CM
const EUR_PALLET_LENGTH_MAX = 120 // CM

class Pallet {
  constructor (units, type = 'CustomPallet') {
    this.units = units
    this.type = type
    this.dimensions = {}
    this.recomendedDims = {}
    this.warnings = []
  }

  setDimensions (dims) {
    this.selectedDims = dims
    return this
  }

  getWarnings () {
    // TODO: implement
  }

  /**
   * return array of possibilities of pallet's dimensions
   * for widths in POSIBLE_PALLET_WIDTH constant
   */
  calculateRecommendations () {
    const totalVolume = this.calcTotalVolume()
    const totalWeight = this.calcTotalWeight()
    const longestEdge = this.calcLongestEdge()

    let length = longestEdge
    if (length < PALLET_LENGTH_MIN - (EDGE_RESERVE * 2)) {
      length = PALLET_LENGTH_MIN - (EDGE_RESERVE * 2)
    }
    // length = Math.ceil(length / 10) * 10
    let width = Math.sqrt(totalVolume / (length * HEIGHT_TO_WIDTH_RATIO))
    if (width < PALLET_WIDTH_MIN) {
      width = PALLET_WIDTH_MIN
    } else {
      width = Math.ceil(width / 10) * 10
    }
    let height = width * HEIGHT_TO_WIDTH_RATIO

    this.recomendedDims = {
      width: Math.ceil(width),
      length: Math.ceil(length + (EDGE_RESERVE * 2)),
      height: Math.ceil(height + HEIGHT_OF_PALLET)
    }

    // Warnings
    let warnings = []
    switch (this.type) {
      case 'EurPallet':
        if (length > EUR_PALLET_LENGTH_MAX - (EDGE_RESERVE * 2)) {
          warnings.push({ severity: 'high', msg: 'max_length_exceeded' })
        }
        if (width > EUR_PALLET_WIDTH_MAX) {
          warnings.push({ severity: 'high', msg: 'max_width_exceeded' })
        }
        if (totalWeight > PALLET_WEIGHT_MAX) {
          warnings.push({ severity: 'high', msg: 'max_weight_exceeded' })
        }
        break
      default:
        if (length > PALLET_LENGTH_MAX - (EDGE_RESERVE * 2)) {
          warnings.push({ severity: 'high', msg: 'max_length_exceeded' })
        }
        if (width > PALLET_WIDTH_MAX) {
          warnings.push({ severity: 'high', msg: 'max_width_exceeded' })
        }
        if (totalWeight > PALLET_WEIGHT_MAX) {
          warnings.push({ severity: 'high', msg: 'max_weight_exceeded' })
        }
        break
    }
    this.warnings = warnings

    // POSIBLE_PALLET_WIDTH.forEach(width => {
    //   const height = width * HEIGHT_TO_WIDTH_RATIO
    //   let length = totalVolume / ((width - (EDGE_RESERVE * 2)) * height)
    //   if (length < longestEdge) {
    //     length = longestEdge
    //   }

    //   // Warnings
    //   let warnings = []
    //   if (length > PALLET_LENGTH_MAX - (EDGE_RESERVE * 2)) {
    //     warnings.push({ severity: 'high', msg: 'max_length_exceeded' })
    //   }
    //   if (totalWeight > PALLET_WEIGHT_MAX) {
    //     warnings.push({ severity: 'high', msg: 'max_weight_exceeded' })
    //   }

    //   let dimensions = {
    //     width: width,
    //     length: length + (EDGE_RESERVE * 2),
    //     height: height + HEIGHT_OF_PALLET,
    //     warnings: warnings
    //   }
    //   this.recomendedDims.push(dimensions)
    // })
    return this
  }

  calcLongestEdge () {
    return this.units.reduce((a, b) => {
      const maxEdge = Math.max(b.dimensions.width, b.dimensions.length)
      return Math.max(a, maxEdge)
    }, 0)
  }

  calcTotalVolume () {
    let totalVolume = 0
    this.units.forEach((unit) => {
      totalVolume += (unit.dimensions.length * unit.dimensions.width * unit.dimensions.height)
    })
    return totalVolume
  }

  calcTotalWeight () {
    let totalWeight = 0
    this.units.forEach((unit) => {
      totalWeight += dropHelpers.calculateUnitWeight(unit)
    })
    return totalWeight
  }
}

export default Pallet
